import React from "react"

import Container from "../../components/UI/Container"
import Heading from "../../components/Heading"
import Text from "../../components/Text"
import Wrapper from "./ebookfaq.style"

const EbookFaq = () => {
  return (
    <Wrapper>
      <Container width="1340px">
        <div className="left-col">
          <div className="content">
            <hr />
            <Heading
              as="h2"
              content="Why else should i check out this guide?"
              className="title"
            />
            <Text
              className="text"
              content="This eBook will be of most value to enterprise-level businesses who need a more agile approach but struggle to implement DevOps into the current IT environment effectively. Whether you have already started your DevOps journey or are looking for guidance on a prospective update, the eBook will cover all key questions on this topic."
            />
          </div>
          <div className="content">
            <hr />
            <Heading
              as="h2"
              content="Why else should i check out this guide?"
              className="title"
            />
            <Text
              className="text"
              content="In just a 10-minute read, you will gain a complete understanding of the DevOps implementation process and best practices for its successful long-term use."
            />
          </div>
        </div>
        <div className="right-col">
          <div className="content">
            <hr />
            <Heading
              as="h2"
              content="Why else should i check out this guide?"
              className="title"
            />
            <Text
              className="text"
              content="99% of IT experts believe DevOps has benefited their firm by enhancing product quality, speed to market, and team performance."
            />
            <Text
              className="text"
              content="The growth of digital enterprises in recent years has compelled players across sectors to improve efficiency, customer satisfaction, and agility. DevOps ticks all the boxes – and we explain how.
"
            />
            <Text
              className="text"
              content="As an added bonus, you’ll get a case study on implementing DevOps from scratch to its full integration into the company’s ERP. "
            />
          </div>
        </div>
      </Container>
    </Wrapper>
  )
}

export default EbookFaq
